/** Преобразует координаты нашего формата в координаты Geo JSON */
export var mapCoordsToYCoords = function mapCoordsToYCoords(coordinates) {
  return [coordinates.lng, coordinates.lat];
};

/** Преобразует координаты Geo JSON в координаты нашего формата */
export var mapYCoordsToCoords = function mapYCoordsToCoords(coordinates) {
  return {
    lng: coordinates[0],
    lat: coordinates[1]
  };
};

/** Преобразует bounding box c координатами нашего формата в bounding box c координатами Geo JSON */
export var mapBBoxToYBBox = function mapBBoxToYBBox(BBox) {
  return [[BBox.topLeft.lng, BBox.bottomRight.lat], [BBox.bottomRight.lng, BBox.topLeft.lat]];
};

/** Преобразует bounding box c координатами Geo JSON в bounding box c координатами нашего формата */
export var mapYBBoxToBBox = function mapYBBoxToBBox(YBBox) {
  return {
    topLeft: {
      lng: YBBox[0][0],
      lat: YBBox[1][1]
    },
    bottomRight: {
      lng: YBBox[1][0],
      lat: YBBox[0][1]
    }
  };
};